// IMPORTANT: Make sure this is in sync with functions/src/index.ts -> prepareDailyDigest
export enum FILTER_TYPE {
    theme = 'themes',
    type = 'type',
    author = 'authors',
}
